import React from 'react'

const Booking = () => {
    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>Get a Free Quote</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="quotepage all-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 wow animate__animated animate__fadeInDown" data-wow-delay="0.3s" data-wow-duration="2s">
                            <div className="heading">
                                <h2>
                                    Get a Free Quote
                                </h2>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt
                                    ut labore et dolore magna aliqua. Ut
                                    enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip eat
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <form>
                            <div className="row">
                                <div className="col-lg-6">
                                    <input type="text" placeholder="Full Name" />
                                </div>
                                <div className="col-lg-6">
                                    <input type="email" placeholder="Email" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <input type="tel" placeholder="Phone Number" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="input-icon">
                                        <input type="date" id="dateInput" required />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="input-icon">
                                        <input type="time" id="timeInput" required />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 arr_border">
                                    <select required>
                                        <option value disabled selected>Service Type</option>
                                        <option value="support">Support</option>
                                        <option value="feedback">Feedback</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <textarea placeholder="Message" defaultValue={""} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <button type="submit" className="theme_btn1">
                                        <div className="theme-btn-inner1">
                                            <div className="btn-text1">Submit NOw</div>
                                            <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Booking